import BaseMuiSwitch, {
    SwitchProps as MuiSwitchProps,
} from "@mui/material/Switch";
import { styled } from "@mui/material/styles";

export const MuiSwitch = styled((props: MuiSwitchProps) => (
    <BaseMuiSwitch
        focusVisibleClassName=".Mui-focusVisible"
        disableRipple
        {...props}
    />
))(({ theme }) => ({
    width: "auto",
    height: "40px",
    aspectRatio: "2 / 1",
    padding: "0",
    "& .MuiSwitch-switchBase": {
        padding: 0,
        transitionDuration: "300ms",
        backgroundColor: "#000",
        color: "#00BA6C",
        position: "absolute",
        top: "50%",
        left: "calc(0% + 5px)",
        transform: "translateX(0%) translateY(-50%)",
        "& + .MuiSwitch-track": {
            backgroundColor: "#000",
        },
        "&.Mui-checked": {
            left: "calc(100% - 5px)",
            transform: "translateX(-100%) translateY(-50%)",
        },
    },
    "& .MuiSwitch-thumb": {
        boxSizing: "border-box",
        width: 30,
        height: 30,
        background: "#00BA6C",
    },
    "& .MuiSwitch-track": {
        borderRadius: 68,
        border: "1px solid #00BA6C",
        backgroundColor: "#000!important",
    },

    [theme.breakpoints.down("sm")]: {
        width: "40px", 
        height: "24px", 
        "& .MuiSwitch-thumb": {
            width: 17, 
            height: 17,
        },
        "& .MuiSwitch-track": {
            borderRadius: 20, 
        },
        "& .MuiSwitch-switchBase": {
            left: "calc(0% + 3px)",
            "&.Mui-checked": {
                left: "calc(100% - 3px)",
            },
        },
    },
})); 